export default __webpack_public_path__ + "static/media/test4.2a274c89.png";